/**
 * @license lucide-vue-next v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const CircleSmall = createLucideIcon("circle-small", [
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }]
]);

export { CircleSmall as default };
//# sourceMappingURL=circle-small.js.map
